import { render, staticRenderFns } from "./WarrantIndemnities.vue?vue&type=template&id=3415167e&scoped=true"
import script from "./WarrantIndemnities.vue?vue&type=script&lang=js"
export * from "./WarrantIndemnities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415167e",
  null
  
)

export default component.exports